import React from "react";
import PropTypes from "prop-types";
import MSplitter from "components/Shared/MSplitter.tsx";
import MDialog from "components/Shared//MDialog.tsx";
import Button from "@mui/material/Button";
import MSectionCollection, {
  MSECTION_MODE_TAB,
  ACTION_SPLIT,
  ACTION_SPLIT_LEFT,
  ACTION_CLOSE,
} from "components/Shared/MSectionCollection";
import { UNMOUNT_STATUS_WARNING } from "components/Shared/MSection.tsx";

// You probably don't want to use this directly, use WrappedMSplitTabView

const MSplitTabView = ({
  tabs,
  leftTabIds,
  rightTabIds,
  firstChildInitialSize,
  unmountInfo,
  initialTabs,
  functions,
}) => {

  const validRightTabs = tabs.filter(tab => rightTabIds.includes(tab.id)).map(tab => tab.id);

  const getTabs = (ids, pushFunc, splitIcon) => {
    const splitTabs = ids.map(id => {
      let tab = tabs.find(t => t.id === id);
      if (tab == null) return {}; // can't find this tab id (hence photos called from getPushToPaneTabs in QuickLists\index.js)
      let actions = [{ code: splitIcon, onClick: () => pushFunc(tab.id) }];
      if (tab?.canClose) actions.push({ code: ACTION_CLOSE, onClick: () => functions.closeTab(tab.id) });

      let section = { ...tab, actions };
      if (functions.getTabUnmountStatus) section = { ...section, ...functions.getTabUnmountStatus(tab.id) };
      if (functions.onTabUnmount) section.onChildUnmount = () => tab.closeOnUnmount ? functions.closeTab(tab.id, true) : functions.onTabUnmount(tab.id);

      return section;
    });
    if (splitTabs.length === 2 && ids.some(id => id === "Exports") && ids.some(id => id === "Photos")) return splitTabs; // in order to feature Exports tab instead of Photos tab on QA case open
    splitTabs.sort((a, b) => a.order - b.order);
    return splitTabs;
  };

  return <>
    {unmountInfo && unmountInfo.canUnmountWarning && (
      <MDialog ariaLabel={"Confirm Close Tab"}
        contentActions={
          unmountInfo.canUnmountStatus === UNMOUNT_STATUS_WARNING ?
            [
              <Button key="yes" onClick={functions.unmountYesAction}>Yes</Button>,
              <Button key="no" onClick={functions.unmountNoAction}>No</Button>
            ] :
            [<Button key="no" onClick={functions.unmountNoAction}>Ok</Button>]
        }>
        {unmountInfo.canUnmountWarning}
      </MDialog>)}
    <MSplitter
      firstChild={
        <div className="padding-page-content full-height">
          <MSectionCollection
            defaultMode={MSECTION_MODE_TAB}
            sections={getTabs(leftTabIds, functions.pushTabRight, ACTION_SPLIT)}
            disableModeChanging
            tabModeCollapsible={false}
            getControlMethods={functions.setLeftControlMethods}
            fullHeight
            initialTab={initialTabs?.first}
          /*
          if persist tabs is true then we have a really odd issue with tab switching
          if you push enough tabs left and right like a maniac eventually the
          left msection collection no longer renders
          */
          //persistTabs
          />
        </div>}
      secondChild={validRightTabs.length > 0 &&
        <div className="padding-page-content full-height">
          <MSectionCollection
            defaultMode={MSECTION_MODE_TAB}
            disableModeChanging
            sections={getTabs(validRightTabs, functions.pushTabLeft, ACTION_SPLIT_LEFT)}
            tabModeCollapsible={false}
            getControlMethods={functions.setRightControlMethods}
            fullHeight
            initialTab={initialTabs?.second}
          //persistTabs
          />
        </div>}
      firstChildInitialSize={firstChildInitialSize}
    />
  </>;
};

MSplitTabView.propTypes = {
  tabs: PropTypes.array.isRequired, // documented in MSectionCollection as 'sections'
  leftTabIds: PropTypes.arrayOf(PropTypes.string),
  rightTabIds: PropTypes.arrayOf(PropTypes.string),
  firstChildInitialSize: PropTypes.string, // passed to MSplitter: number | string, // CSS style
  functions: PropTypes.object, // from useMSplitTabView
  initialTabs: PropTypes.object, // undocumented data structure
  unmountInfo: PropTypes.object, // undocumented data structure
};

export default MSplitTabView;
